







import { defineComponent, useRoute, watch } from '@nuxtjs/composition-api'
import { useModal } from '~/composables/ui/useModal'

export default defineComponent({
  name: 'AppModal',

  setup() {
    const { state, close } = useModal()

    const route = useRoute()
    watch(
      () => route.value.path,
      () => {
        close()
      }
    )

    return {
      state,

      close,
    }
  },
})
